"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregateError = void 0;
const actions_core_1 = require("@segment/actions-core");
const ResponseError_1 = require("./ResponseError");
class AggregateError extends actions_core_1.IntegrationError {
    constructor(errors, code, status, data, message) {
        super(message || 'Multiple errors', code, status);
        this.errors = errors;
        this.data = data;
    }
    static create(args) {
        const firstErrorInfo = ResponseError_1.getErrorDetails(args.takeCodeAndStatusFromError ? args.takeCodeAndStatusFromError : args.errors[0]);
        if (!args.code)
            args.code = firstErrorInfo.code;
        if (!args.status)
            args.status = firstErrorInfo.status;
        let message = `Multiple errors (${args.errors.length}): ${args.errors
            .map((e) => ResponseError_1.getErrorDetails(e).message)
            .join(', ')}`;
        message = args.message?.(message) || message;
        return new AggregateError(args.errors, args.code, args.status, undefined, message);
    }
}
exports.AggregateError = AggregateError;
//# sourceMappingURL=AggregateError.js.map